
import { UserDevice } from "@/models/user-device";
import { CompanyUserDeviceService } from "@/services/company-user-device-service";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			devices: [] as UserDevice[]
		};
	},
	props: {
		device: {
			type: Object as ()=>UserDevice,
			required: true
		},
		companyId: {
			type: Number,
			required: true
		}
	},
	computed: {
		title():string{
			if (this.device.id){
				return "Toestel bewerken";
			}
			return "Toestel aanmaken";
		},
		deviceIdLabel():string{
			return "Moederbord serial nummer (Indien leeg wordt dit automatisch ingevuld de volgende keer als deze gebruiker aanmeld)";
		},
		isNameUnique():boolean {
			return this.devices.find(f=>f.name.trim() == this.device.name.trim() && this.device.id != f.id) == null;
		},
		isNameValid():boolean {
			if (this.device.name.trim() == "") {
				return false;
			}
			if (!this.isNameUnique){
				return false;
			}
			return true;
		},
		saveDisabled():boolean {
			return !this.isNameValid;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			this.device.companyId = this.companyId;
			if (this.device.id == 0){
				var result = await CompanyUserDeviceService.createDevice(this.device);
			}else{
				var result = await CompanyUserDeviceService.updateDevice(this.device);
			}
			this.$emit("input", result);
			this.close();
		}
	},
	async mounted(){
		this.devices = await CompanyUserDeviceService.listDevices(this.companyId);
		if (this.device.id !=0)return;
		let baseName = this.device.name.trim();
		let digit = 1;
		let nameUnique = false;
		do {
			let name = baseName;
			if (digit > 1){
				name = `${name} ${digit}`;
			}
			let foundDevice = this.devices.find(f=>f.name.trim() == name);
			nameUnique = foundDevice == null;
			if (!nameUnique){
				digit++;
			}else{
				this.device.name = name;
			}
		}while(!nameUnique);
	}
});
